const NotFound = () => {
  return (
    <div style={{ display: 'flex', justifyContent: "center", alignItems: "center", fontSize: "20px" }}>
      <h1>404 | Not Found</h1>
    </div>
  );
}
export default NotFound;